import "./v2-question-surface.css";

export default function PageTransition({ children, direction = "forward" }) {
  return (
    <div className="tgc-v2-transition" data-direction={direction}>
      {children}
    </div>
  );
}
